import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { ContactsApi } from 'entities/Contacts'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useContactsTableContext } from 'pages/contacts/ui/ContactsTable/context/contactsTableContext'
import styles from './styles.module.scss'

export const ExportButton = observer(() => {
  const { usersStore } = useEntitiesContext()
  const { user } = usersStore
  const activeFields = user ? user.activeFields : []
  const contactsTableStore = useContactsTableContext()
  const { total, tableStore, title, exportStore } = contactsTableStore
  const { selectedIds, bulkAllMode } = tableStore
  const maxCount = 100_000
  const showDownload =
    selectedIds.length && !bulkAllMode ? selectedIds.length < maxCount : total < maxCount

  const getTitle = () => {
    if (!selectedIds.length || bulkAllMode) {
      return `Export -> ${title}`
    }

    return `Export -> ${selectedIds.length === 1 ? '1 contact' : `${selectedIds.length} contacts`}`
  }

  return (
    <Button
      icon='download'
      text='Export'
      typeBtn='contained'
      contained='tertiary'
      size='small'
      className={styles.exportButton}
      onClick={() => {
        exportStore.getExport({
          promise: ContactsApi.getExport({
            ...contactsTableStore.expandedParams,
            contact_columns: activeFields,
            contactIds: selectedIds as number[],
            ...(bulkAllMode && { contactIds: [] }),
          }),
          showDownload,
          preparingTitle: getTitle(),
          successTitle: getTitle(),
        })
      }}
    />
  )
})
